import React, { memo, useMemo } from "react";
import { Box, Button, Stack } from "@mui/material";
import { useFormikContext } from "formik";

import FormikMuiSaveAsDraftButton from "@/components/muiCustom/buttons/FormikMuiSaveAsDraftButton";
import { rrdDirectMailCampaignHelper } from "../utils/rrdDirectMailHelper";

type RRDSubmitTopProps = {
  isPreview?: boolean;
};

function RRDSubmitTop({ isPreview = false }: RRDSubmitTopProps) {
  const { values } = useFormikContext<Record<string, any>>();

  const fullyFilledLocations = useMemo(() => {
    const locations = { ...values };
    delete locations.is_draft;
    return rrdDirectMailCampaignHelper.fetchFullyFilledLocations(locations);
  }, [values]);

  return (
    <Box sx={{ maxWidth: "100%" }} className="py-2 mr-4">
      <Stack
        direction="row"
        spacing={1}
        sx={{ width: "100%" }}
        justifyContent={{
          xs: "space-between",
          sm: "flex-end",
        }}
      >
        {!isPreview && (
          <FormikMuiSaveAsDraftButton
            label="Save for Later"
            variant="outlined"
            color="primary"
            disabled={!fullyFilledLocations?.length}
            size="small"
          />
        )}
        <Button
          size="small"
          variant="contained"
          color="primary"
          type="submit"
          disabled={!fullyFilledLocations?.length}
          className="px-3"
        >
          Confirm Selections
        </Button>
      </Stack>
    </Box>
  );
}

export default memo(RRDSubmitTop);
